import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { BaseFeatureState } from '@cast/infrastructure-abilities';

type FeedbackToolbarState = BaseFeatureState & {
  hidden: boolean;
  toggle: () => void;
};

export const useFeedbackToolbar = create<FeedbackToolbarState>()(
  persist(
    (setState, getState) => ({
      hidden: true,
      getIsActive: () => !getState().hidden,
      toggle: () => setState((state) => ({ hidden: !state.hidden })),
    }),
    {
      name: 'feedback-toolbar',
      partialize: (state) => ({ hidden: state.hidden }),
    }
  )
);
